var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaboratorios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FDF5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6666 6.66675V13.3334H53.3333V60.0001C53.3333 67.3668 47.3666 73.3334 39.9999 73.3334C32.6333 73.3334 26.6666 67.3668 26.6666 60.0001V13.3334H23.3333V6.66675H56.6666ZM46.6666 33.3334H33.3333V60.0001C33.3333 63.6834 36.3166 66.6668 39.9999 66.6668C43.6833 66.6668 46.6666 63.6834 46.6666 60.0001V33.3334ZM43.3333 50.0001C45.1733 50.0001 46.6666 51.4934 46.6666 53.3334C46.6666 55.1734 45.1733 56.6668 43.3333 56.6668C41.4933 56.6668 39.9999 55.1734 39.9999 53.3334C39.9999 51.4934 41.4933 50.0001 43.3333 50.0001ZM36.6666 40.0001C38.5066 40.0001 39.9999 41.4934 39.9999 43.3334C39.9999 45.1734 38.5066 46.6667 36.6666 46.6667C34.8266 46.6667 33.3333 45.1734 33.3333 43.3334C33.3333 41.4934 34.8266 40.0001 36.6666 40.0001ZM46.6666 13.3334H33.3333V26.6667H46.6666V13.3334Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratorios);
export default __webpack_public_path__ + "static/media/Laboratorios.798130200922dad8a3f943795c24f598.svg";
export { ForwardRef as ReactComponent };